import { useEffect, useMemo, useState } from "react";

import { ServiceRequest } from "@medplum/fhirtypes";
import { useMedplum } from "@medplum/react";

import { Button, Table } from "@mantine/core";

import { fetchLabOrderResultsMessage } from "@/health-gorilla/services/labs";
import { getLabOrderReceivedDate } from "@/health-gorilla/utils/labs";

import LabResultsNoteText from "../LabResultsNoteText";

import LabOrderName from "./LabOrderName";

interface LabOrdersClientRowProps {
  result: ServiceRequest;
  onView: (labOrder: ServiceRequest) => void;
}

export default function LabOrdersClientRow({ result, onView }: LabOrdersClientRowProps) {
  const medplum = useMedplum();
  const [message, setMessage] = useState<string>("");

  useEffect(() => {
    (async () => {
      const message = await fetchLabOrderResultsMessage(medplum, result);
      setMessage(message);
    })();
  }, [medplum, result]);

  const receivedDate = useMemo(() => getLabOrderReceivedDate(result), [result]);

  const handleView = () => {
    onView(result);
  };

  return (
    <Table.Tr>
      <Table.Td colSpan={4}>
        <LabOrderName labOrder={result} />
      </Table.Td>
      <Table.Td colSpan={2}>{receivedDate}</Table.Td>
      <Table.Td colSpan={4}>
        <LabResultsNoteText note={message} />
      </Table.Td>
      <Table.Td ta="right" colSpan={2}>
        <Button variant="outline" onClick={handleView}>
          View Details
        </Button>
      </Table.Td>
    </Table.Tr>
  );
}
